__turbopack_context__.v({
  "answer": "YoBWaq_answer",
  "answerEm": "YoBWaq_answerEm",
  "body": "YoBWaq_body",
  "bodyDesktop": "YoBWaq_bodyDesktop",
  "bodyMobile": "YoBWaq_bodyMobile",
  "bubble": "YoBWaq_bubble",
  "caption": "YoBWaq_caption",
  "card": "YoBWaq_card",
  "cardBody": "YoBWaq_cardBody",
  "cardTitle": "YoBWaq_cardTitle",
  "chat": "YoBWaq_chat",
  "explainBody": "YoBWaq_explainBody",
  "explainCopy": "YoBWaq_explainCopy",
  "explainIcon": "YoBWaq_explainIcon",
  "explainItem": "YoBWaq_explainItem",
  "explainList": "YoBWaq_explainList",
  "explainTitle": "YoBWaq_explainTitle",
  "eyebrow": "YoBWaq_eyebrow",
  "grid": "YoBWaq_grid",
  "howItWorksLivePulse": "YoBWaq_howItWorksLivePulse",
  "image": "YoBWaq_image",
  "inner": "YoBWaq_inner",
  "intro": "YoBWaq_intro",
  "liveDot": "YoBWaq_liveDot",
  "liveLabel": "YoBWaq_liveLabel",
  "media": "YoBWaq_media",
  "metric": "YoBWaq_metric",
  "metricLabel": "YoBWaq_metricLabel",
  "metricValue": "YoBWaq_metricValue",
  "metrics": "YoBWaq_metrics",
  "overlay": "YoBWaq_overlay",
  "overlayExplains": "YoBWaq_overlayExplains",
  "overlayInsights": "YoBWaq_overlayInsights",
  "overlayWear": "YoBWaq_overlayWear",
  "picture": "YoBWaq_picture",
  "question": "YoBWaq_question",
  "scrim": "YoBWaq_scrim",
  "section": "YoBWaq_section",
  "time": "YoBWaq_time",
  "title": "YoBWaq_title",
  "titleDesktop": "YoBWaq_titleDesktop",
  "titleMobile": "YoBWaq_titleMobile",
  "wear": "YoBWaq_wear",
});
